import { RotateCcw } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const resetButtonClassName = cn(
  'shrink-0 font-normal text-muted-foreground hover:text-foreground disabled:opacity-40',
  'h-6 gap-1 px-1 text-xs sm:h-8 sm:px-1.5 md:h-9 md:gap-1.5 md:px-2 md:text-sm',
);

export interface ResetButtonProps {
  disabled?: boolean;
  onClick: () => void;
  className?: string;
  hideLabel?: boolean;
}

export function ResetButton({ disabled, onClick, className, hideLabel }: ResetButtonProps) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="sm"
      className={cn(resetButtonClassName, className)}
      aria-label="Reset filters"
      disabled={disabled}
      onClick={onClick}
    >
      <RotateCcw className="size-3 shrink-0 sm:size-4" aria-hidden />
      {!hideLabel && <span className="hidden md:inline">Reset</span>}
    </Button>
  );
}
